// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type KundeListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SucheKundenQuery = {
  search?: string;
  filtered?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useSucheKunden(): (
  query: SucheKundenQuery
) => Promise<KundeListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (query = {}) => (await getAPI()).kunden.sucheKunden({ ...query }),
    [getAPI]
  );
}
